import { Loading } from "notiflix/build/notiflix-loading-aio";

const isEn = window.location.pathname.includes("/en");

const t = {
	noQuotes: isEn
		? "At the moment, there are no quotes available"
		: "На зараз котирувань немає",
	isin: "ISIN",
	currency: isEn ? "Issue Currency" : "Валюта емісії",
	maturity: isEn ? "Maturity Date" : "Дата погашення",
	yieldSell: isEn ? "Yield on Sell" : "Дохідність продажу",
	yieldSellAst: isEn
		? 'Yield on Sell <span class="asterix">**</span>'
		: 'Дохідність продажу <span class="asterix">**</span>',
	sell: isEn ? "Sell Price (UAH)" : "Продаж (UAH)",
	buy: isEn ? "Buy Price (UAH)" : "Купівля (UAH)",
	yieldBuy: isEn ? "Yield on Buy" : "Дохідність купівлі",
	yieldBuyAst: isEn
		? 'Yield on Buy <span class="asterix">**</span>'
		: 'Дохідність купівлі <span class="asterix">**</span>',
	company: isEn ? "Company" : "Компанія",
	symbol: isEn ? "Symbol" : "Біржовий тікер",
	filterTitle: isEn ? "Filter by maturity year" : "Фільтр по роках погашення",
};

const formatDate = dateString =>
	new Intl.DateTimeFormat("uk-UA").format(new Date(dateString));
const formatPercent = value => `${value}%`;

const ASSETS_CONFIG = {
	BONDS: {
		id: 0,
		containerClass: ".bonds-table",
		headerClass: ".bonds-header",
		itemClass: "bonds-quote-item",
		onRender: initBondsFilter,
		fields: [
			{ key: "isin", label: t.isin },
			{ key: "currency_detail", label: t.currency },
			{ key: "maturity_date", label: t.maturity, format: formatDate },
			{ key: "annual_rate", label: t.yieldSell, format: formatPercent },
			{ key: "price", label: t.sell },
			{ key: "sell_price", label: t.buy },
			{ key: "sell_annual_rate", label: t.yieldBuy, format: formatPercent },
		],
	},
	EUROBONDS: {
		id: 1,
		containerClass: ".eurobonds-table",
		headerClass: ".eurobonds-header",
		itemClass: "bonds-quote-item",
		fields: [
			{ key: "isin", label: t.isin },
			{ key: "currency_detail", label: t.currency },
			{ key: "maturity_date", label: t.maturity, format: formatDate },
			{ key: "annual_rate", label: t.yieldSellAst, format: formatPercent },
			{ key: "price", label: t.sell },
			{ key: "sell_price", label: t.buy },
			{ key: "sell_annual_rate", label: t.yieldBuyAst, format: formatPercent },
		],
	},
	STOCKS: {
		id: 2,
		containerClass: ".stocks-table",
		headerClass: ".stocks-header",
		itemClass: "stocks-quote-item",
		fields: [
			{ key: "company", label: t.company },
			{ key: "title", label: t.symbol },
			{ key: "isin", label: t.isin },
			{ key: "currency_detail", label: t.currency },
			{ key: "price", label: t.sell },
			{ key: "sell_price", label: t.buy },
		],
	},
	CORPORATE: {
		id: 3,
		containerClass: ".corporate-table",
		headerClass: ".corporate-header",
		itemClass: "corporates-quote-item",
		fields: [
			{ key: "company", label: t.company },
			{ key: "isin", label: t.isin },
			{ key: "currency_detail", label: t.currency },
			{ key: "maturity_date", label: t.maturity, format: formatDate },
			{ key: "annual_rate", label: t.yieldSell, format: formatPercent },
			{ key: "price", label: t.sell },
			{ key: "sell_price", label: t.buy },
			{ key: "sell_annual_rate", label: t.yieldBuy, format: formatPercent },
		],
	},
};

async function fetchAssetData(assetId) {
	try {
		const response = await fetch(
			"https://trading.btc-broker.com/uk/api/getAssets",
			{
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(assetId),
			},
		);

		if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

		const data = await response.json();
		return data.results && data.results.length > 0 ? data.results : null;
	} catch (error) {
		console.error(`Error fetching data for asset ID ${assetId}:`, error);
		return null;
	}
}

function createMarkup(quotes, config) {
	return quotes
		.map(
			quote => `
    <li class="${config.itemClass}">
      ${config.fields
				.map(
					field => `
        <div class="bonds-quote-element">
          <span class="bonds-quote-element-header">${field.label}</span>
          <p class="bonds-quote-element-text">
            ${field.format ? field.format(quote[field.key]) : quote[field.key]}
          </p>
        </div>
      `,
				)
				.join("")}
    </li>
  `,
		)
		.join("");
}

function initBondsFilter(quotes, config) {
	const container = document.querySelector(config.containerClass);
	const header = document.querySelector(config.headerClass);

	let filterContainer = document.querySelector(".bonds-year-filter");

	const uniqueYears = [
		...new Set(quotes.map(q => q.maturity_date.substring(0, 4))),
	].sort();

	filterContainer.innerHTML = `
    <p class="year-filter-title">${t.filterTitle}</p>
    <div class="year-filter-buttons">
      ${uniqueYears
				.map(
					year => `
        <label class="year-filter-label">
          <input type="checkbox" value="${year}" class="year-checkbox">
          <span class="year-filter-btn">${year}</span>
        </label>
      `,
				)
				.join("")}
    </div>
  `;

	const updateTable = () => {
		const selectedCheckboxes = document.querySelectorAll(
			".year-checkbox:checked",
		);
		const selectedYears = Array.from(selectedCheckboxes).map(cb => cb.value);

		let filteredQuotes = quotes;

		if (selectedYears.length > 0 && selectedYears.length < uniqueYears.length) {
			filteredQuotes = quotes.filter(q =>
				selectedYears.includes(q.maturity_date.substring(0, 4)),
			);
		}

		container.classList.add("is-updating");

		setTimeout(() => {
			if (filteredQuotes.length > 0) {
				if (header) header.classList.remove("hidden");
				container.innerHTML = createMarkup(filteredQuotes, config);
			} else {
				if (header) header.classList.add("hidden");
				container.innerHTML = `<li class="no-quotes-message"><h4 class="bonds-quote-group-title">${t.noQuotes}</h4></li>`;
			}

			container.classList.remove("is-updating");
		}, 250);
	};

	const checkboxes = document.querySelectorAll(".year-checkbox");
	checkboxes.forEach(cb => cb.addEventListener("change", updateTable));

	updateTable();
}

async function renderAssetTable(config) {
	const container = document.querySelector(config.containerClass);
	const header = document.querySelector(config.headerClass);

	if (!container) return;

	const quotes = await fetchAssetData(config.id);

	if (!quotes) {
		container.innerHTML = `<li class="no-quotes-message"><h4 class="bonds-quote-group-title">${t.noQuotes}</h4></li>`;
		return;
	}

	if (config.onRender) {
		config.onRender(quotes, config);
	} else {
		if (header) header.classList.remove("hidden");
		container.innerHTML = createMarkup(quotes, config);
	}
}

async function initTables() {
	Loading.dots({ svgColor: "#3757be", backgroundColor: "#5978a399" });

	try {
		const renderPromises = Object.values(ASSETS_CONFIG).map(config =>
			renderAssetTable(config),
		);

		await Promise.allSettled(renderPromises);
	} finally {
		Loading.remove();
	}
}

initTables();
